import { deriveCaseManagementWarning, showCaseManagement } from '~support-at-home/lib/derive';
import { onChangeSahBudgets } from '~support-at-home/lib/onchange';
import { validateDateRange } from '~support-at-home/lib/validate';

import { Definition } from '~components/form-fields/Fields';

import { getAll as getAllClientBudgetStatuses } from '~support-at-home/actions/clientBudgetStatuses';

import { selectClientBudgetStatuses } from '~support-at-home/selectors/clientBudgetStatuses';
import { lookupSahBudgets } from '~support-at-home/selectors/sahBudgets';

const fields: Definition[] = [
  {
    key: 'start_date',
    type: 'date',
    caption: 'Start Date',
    validate: validateDateRange,
    order: 100,
  },
  {
    key: 'end_date',
    type: 'date',
    caption: 'End Date',
    validate: validateDateRange,
    order: 200,
  },
  {
    key: 'status_id',
    type: 'select',
    caption: 'Status',
    selectorActions: getAllClientBudgetStatuses,
    selectorOptions: selectClientBudgetStatuses,
    order: 300,
  },
  {
    key: 'client_sah_budget_id',
    type: 'select',
    caption: 'SAH Budget',
    selectorOptions: lookupSahBudgets,
    onChange: onChangeSahBudgets,
    clearable: true,
    noOptionsMessage: 'No SAH budgets found for selected client',
    order: 350,
  },
  {
    key: 'total_amount',
    type: 'currency',
    caption: 'Total Amount',
    disabled: (values: Record<string, unknown>) => !!values.client_sah_budget_id,
    order: 400,
  },
  {
    key: 'total_includes_case_management',
    type: 'switch',
    caption: 'Includes Case Management',
    show: showCaseManagement,
    deriveWarning: deriveCaseManagementWarning,
    order: 500,
  },
];

export default fields;
